import classNames from 'classnames'

import { Button, ConfirmationModal } from 'iq-blueberry'

import DocumentExampleModal from '../DocumentsUpload/DocumentExampleModal'
import Camera from 'components/common/Camera'
import Img from 'components/common/Img'
import ModalOneButton from 'components/common/ModalOneButton'

import { useTakePhotoButton } from './hook'
import './style.styl'
import OutlineAngleRightMini from 'iq-blueberry/dist/reactIcons/OutlineAngleRightMini'

export const TakePhotoButton = ({
  showMask = false,
  maskType,
  fileReference,
  side,
  docType,
  filesReferencesState,
  modifyPayloadKeys,
  reviewImageText,
  buttonTheme,
  handleStepAfterUpload,
  facing = "user",
  hasUploadError = false,
  onChange
}) => {
  const {
    closeDocumentModal,
    handleDocumentModalButton,
    isDocumentModalOpen,
    shouldOpenCamera,
    setShouldOpenCamera,
    uploadCameraImage,
    buttonText,
    isLoadingUpload,
    showConfirmationModal,
    isModalVisible,
    hideConfirmationModal,
    handleDelete,
    currentFileReference,
    handleButtonCameraOption,
    hasCameraAllowed,
    hasCameraAllowedState,
    isActivePermissionModal,
    handleClosePermissionModal,
    isActivePendingPermissionModal,
    handleClosePendingPermissionModal,
    hasUploadedSide,
    shouldShowDocumentModal
  } = useTakePhotoButton({ fileReference, side, filesReferencesState, modifyPayloadKeys, handleStepAfterUpload, hasUploadError, onChange })

  const [filesReferences] = filesReferencesState
  const cameraIcon = buttonTheme === "primary" ? "camera-white-icon" : "new-document-icon"

  return (
    <div className="bb-take-photo__container">
      <div
        className={classNames('bb-take-photo', buttonTheme, {
          '-uploaded': hasUploadedSide && buttonTheme != "primary",
        })}
        onClick={handleButtonCameraOption}>
        <div className="bb-take-photo__content">
          <div className="bb-take-photo__content-first">
            {(isLoadingUpload[side] || hasUploadedSide) && buttonTheme != "primary"  ? (
              <Img src="images/check-green.svg" />
            ) : (
              <Img src={`images/${cameraIcon}.svg`} />
            )}
            {buttonText}
          </div>
          {!hasUploadedSide && buttonTheme != "primary" && <OutlineAngleRightMini />}
        </div>

      </div>
        {hasUploadedSide && buttonTheme != "primary" && (
          <Button
            expand='x'
            justify='start'
            type="text" 
            iconRight 
            Icon={OutlineAngleRightMini} 
            onClick={showConfirmationModal}
            style={{margin: '0'}}>
            Gostaria de tirar outra foto?
          </Button>
        )}
      <ConfirmationModal
        title="Tem certeza que deseja tirar outra foto?"
        text="Novas imagens serão necessárias para continuar."
        dangerButtonText="Tirar outra foto"
        buttonText="Cancelar"
        isActive={isModalVisible}
        handleCloseModal={hideConfirmationModal}
        handleDangerButton={handleDelete}
        handleButton={hideConfirmationModal}
      />

      { hasCameraAllowed 
        ? shouldShowDocumentModal &&
          <DocumentExampleModal
            side={side}
            docType={docType}
            handleOpenModal={handleDocumentModalButton}
            isActive={isDocumentModalOpen}
            handleCloseModal={closeDocumentModal}
          />
        : <ModalOneButton
          title="Você não autorizou o uso da câmera"
          text="Não conseguimos autorização para abrir câmera do seu dispositivo para tirar a foto. Por favor, revise as permissões do navegador e tente novamente."
          buttonText="Tentar novamente"
          hasCloseButton={false}
          isActive={isActivePermissionModal}
          handleButton={handleClosePermissionModal}
        /> }
      
      {shouldOpenCamera ? (
        <Camera
          showMask={showMask}
          maskType={maskType}
          facing={facing}
          outputType="blob"
          reviewImageTitle="A foto está boa?"
          reviewImageText={reviewImageText}
          closeStreamOnTakePicture
          onTakePicture={uploadCameraImage}
          hasCameraAllowedState={hasCameraAllowedState}
          setShouldOpenCamera={setShouldOpenCamera}
        />
      ) : null}
    </div>
  )
}
